import { createSlice } from '@reduxjs/toolkit';

export const HIDE_TOCK_INTERSTITIAL = 'hide_tock_interstitial';

const shouldHideTockInterstitial = () => {
  if (typeof window === 'undefined') return false;

  try {
    return window.localStorage.getItem(HIDE_TOCK_INTERSTITIAL) === 'true';
  } catch {
    return false;
  }
};

const initialState = {
  isOpen: false,
  pendingUrl: null,
};

const tockInterstitialSlice = createSlice({
  name: 'tockInterstitial',
  initialState,
  reducers: {
    openTockInterstitial: (state, action) => {
      state.isOpen = true;
      state.pendingUrl = action.payload?.url ?? null;
    },
    closeTockInterstitial: (state) => {
      state.isOpen = false;
      state.pendingUrl = null;
    },
  },
});

export const {
  openTockInterstitial,
  closeTockInterstitial,
} = tockInterstitialSlice.actions;

const openTockInterstitialIfEligible = (url) => (dispatch) => {
  if (!url || typeof window === 'undefined') return;

  const shouldOpenInterstitial = !shouldHideTockInterstitial();
  if (shouldOpenInterstitial) {
    dispatch(openTockInterstitial({ url }));
    return;
  }

  window.open(url, '_blank', 'noopener');
};

export { openTockInterstitialIfEligible };

export default tockInterstitialSlice.reducer;
